import { Drawer } from '@mui/material';
import { bool, func, string, number, array, object } from "prop-types";
import React from "react";
import styled from "styled-components";
import styles from "./index.scss";
import { getRouter, checkContainsString } from '../../utils/helper';
import { tryBase64Decode } from "../../utils/helper"
// 创建两个不同的 Drawer 样式
const StyledDrawerPC = styled(Drawer)`
background-color: transparent;
display: flex;
justify-content: center;
align-items: center;
.MuiPaper-root{ 
  width: 430px;
  height: 256px;
  top: 0;
  left: 0;
  border-radius: 10px;
  position: initial;
  -webkit-flex: inherit;
}
`;
const StyledDrawerMobile = styled(Drawer)`
  background-color: transparent;
  .MuiPaper-root {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
`;



const QuantityReminderPopup = (props) => {
  const {
    breakpoint, showModal, setShowModal, onConfirm, onCancel,
    title, cancelBtnText, confirmBtnText, product, pageType,
    type, openCount, confirmUrl, activityCode, configList, adaObj,
  } = props;
  const isDesktop = breakpoint === "md" || breakpoint == "lg" || breakpoint == "xl";
  const router = getRouter();
  const StyledDrawerComponent = isDesktop ? StyledDrawerPC : StyledDrawerMobile;
  const setRemindedItemCodeArr = (itemCode) => {
    const itemCodeArray = JSON.parse(sessionStorage.getItem('REMINDED_ITEM_CODE_ARR'));
    const REMINDED_ITEM_CODE_ARR = itemCodeArray ?? [];
    if (!REMINDED_ITEM_CODE_ARR.includes(itemCode)) {
      REMINDED_ITEM_CODE_ARR.push(itemCode);
      sessionStorage.setItem('REMINDED_ITEM_CODE_ARR', JSON.stringify(REMINDED_ITEM_CODE_ARR))
    }
  }

  const handleConfirm = () => {
    if (openCount == 'once') {
      setRemindedItemCodeArr(activityCode);
    }
    if (type == 'popup') {
      // window.open(confirmUrl, '_blank')
      const { origin } = window?.location || {};
      window.open(origin + '/' + confirmUrl, '_self')
    } else {
      onConfirm(configList, adaObj, product);
    }
  }

  const handleCancel = () => {
    if (openCount == 'once') {
      setRemindedItemCodeArr(activityCode);
    }
    setShowModal(false);
    const t = setTimeout(() => {
      clearTimeout(t);
      if (type === 'switch' || pageType == 'cart') {
        onCancel(type);
      } else {
        onCancel(onCartClick);
      }
    }, 100);
  }

  const onCartClick = () => {
    try {
      if (!router?.asPath) return;
      const asPath = router?.asPath;
      const conditionalEnumeration = asPath.indexOf("utm_source") == -1 && asPath.indexOf("utm_medium") == -1 && asPath.indexOf("utm_campaign") == -1 && asPath.indexOf("utm_term") == -1;
      /**
       * 當用戶在登錄頁面點擊購物車按鈕時。
       * 此時需要判斷當前路徑參數是否轉碼。
       * 如果路徑轉碼，需要主動解碼。
       * 避免影響 UTM 參數在路徑跳轉中丟失
       * */
      if (asPath.indexOf("h=") != -1 && conditionalEnumeration) {
        if (!asPath.includes("?")) return ''
        let arr = asPath.split('?')
        let query = arr[1];
        //  判断一个字符串是否需要使用 atob 解码
        if (tryBase64Decode(query.split("=")[1])) {
          let parameter = atob(query.split("=")[1])
          if (router) router.push(`/cart?p=${parameter.replace(/[?]+/g, '&')}`);
        } else {
          if (checkContainsString(query)) {
            // 检查参数中是否有 p= 相关参数
            if (router) router.push(`/cart?p=${query.split('p=')[1]}`);
          } else if (query.indexOf("h=") != -1) {
            // 检查参数中是否有 h= 相关参数
            if (router) router.push(`/cart?p=${query.split('h=')[1]}`);
          } else {
            //  直接设置首页为上一页
            if (router) router.push(`/cart?p=/`);
          }
        }
      } else {
        if (router) router.push(`/cart?p=${asPath.replace(/[?]+/g, '&')}`);
      }
    } catch (error) {
      console.log('onCartClick >> catch:', error);
    }
  };


  return (
    <StyledDrawerComponent open={showModal} variant="temporary"
      anchor={isDesktop ? 'top' : 'bottom'} className={styles.Drawer__containerSop}>
      <div className={isDesktop ? styles.desktop : styles.mobileTerminal}>
        <div className={styles.content}>
          <div className={styles.headerInformation}>{title}</div>
          <div className={styles.footerButtom}>
            {cancelBtnText && <div className={styles.cancelBtn} onClick={handleCancel}>{cancelBtnText}</div>}
            <div className={styles.confirmBtn} onClick={handleConfirm}>{confirmBtnText}</div>
          </div>
        </div>
      </div>
    </StyledDrawerComponent>
  );
};
//API
QuantityReminderPopup.defaultProps = {
  breakpoint: 'lg',
  showModal: false,
  title: '',
  cancelBtnText: '',
  confirmBtnText: '確認',
  type: 'popup',
  openCount: 'once',
  confirmUrl: '',
  activityCode: '',
  index: 0,
  pageType: '',
  configList: [],
  adaObj: {},
  product: {},
  setShowModal: () => { },
  onCancel: () => { },
  onConfirm: () => { },
};

//參數類型
QuantityReminderPopup.propTypes = {
  breakpoint: string,
  showModal: bool,
  title: string,
  cancelBtnText: string,
  confirmBtnText: string,
  type: string,
  openCount: string,
  confirmUrl: string,
  activityCode: string,
  index: number,
  pageType: string,
  configList: array,
  adaObj: object,
  product: object,
  setShowModal: func,
  onConfirm: func,
  onCancel: func,
};
export default QuantityReminderPopup;
